"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Layout = exports.ChartType = exports.SurveyType = exports.QuizConfig = exports.QuestionType = exports.OptionType = exports.RESET_SURVEY = exports.SUBMIT_SURVEY_RESPONSE = exports.UPDATE_SURVEY_RESPONSE = exports.GET_USER_RESPONSE = exports.GET_SURVEY_DETAILS = void 0;
var Layout;
(function (Layout) {
    Layout["RADIO"] = "RADIO";
    Layout["DROPDOWN"] = "DROPDOWN";
})(Layout || (exports.Layout = Layout = {}));
var SurveyType;
(function (SurveyType) {
    SurveyType["SURVEY"] = "SURVEY";
    SurveyType["POLL"] = "POLL";
    SurveyType["QUIZ"] = "QUIZ";
})(SurveyType || (exports.SurveyType = SurveyType = {}));
var OptionType;
(function (OptionType) {
    OptionType["OPTION"] = "OPTION";
    OptionType["OTHER"] = "OTHER";
})(OptionType || (exports.OptionType = OptionType = {}));
var QuestionType;
(function (QuestionType) {
    QuestionType["FREE_RESPONSE"] = "FREE_RESPONSE";
    QuestionType["SINGLE_SELECT"] = "SINGLE_SELECT";
    QuestionType["MULTI_SELECT"] = "MULTI_SELECT";
})(QuestionType || (exports.QuestionType = QuestionType = {}));
var ChartType;
(function (ChartType) {
    ChartType["PIE"] = "PIE";
    ChartType["HORIZONTAL"] = "HORIZONTAL";
})(ChartType || (exports.ChartType = ChartType = {}));
var QuizConfig;
(function (QuizConfig) {
    QuizConfig["COMPLETE"] = "COMPLETE";
    QuizConfig["ANSWER_ALL"] = "ANSWER_ALL";
    QuizConfig["ANSWER_SOME"] = "ANSWER_SOME";
    QuizConfig["COMPLETE_ALL_CORRECT"] = "COMPLETE_ALL_CORRECT";
})(QuizConfig || (exports.QuizConfig = QuizConfig = {}));
const GET_SURVEY_DETAILS = 'survey/pbl/GET_SURVEY_DETAILS';
exports.GET_SURVEY_DETAILS = GET_SURVEY_DETAILS;
const GET_USER_RESPONSE = 'survey/pbl/GET_USER_RESPONSE';
exports.GET_USER_RESPONSE = GET_USER_RESPONSE;
const UPDATE_SURVEY_RESPONSE = 'survey/pbl/UPDATE_SURVEY_RESPONSE';
exports.UPDATE_SURVEY_RESPONSE = UPDATE_SURVEY_RESPONSE;
const SUBMIT_SURVEY_RESPONSE = 'survey/pbl/SUBMIT_SURVEY_RESPONSE';
exports.SUBMIT_SURVEY_RESPONSE = SUBMIT_SURVEY_RESPONSE;
const RESET_SURVEY = 'survey/pbl/RESET_SURVEY';
exports.RESET_SURVEY = RESET_SURVEY;
//# sourceMappingURL=types.js.map